import React from 'react'
import { component_tool } from '@/tool'
let { WizDataTable, WizIcon, WizButton, WizDivider } = component_tool

export default (self, employees, other) => {
    return [
        {
            title: 'id',
            name: 'id',
            formItem: {
                type: 'hidden'
            }
        },
        {
            title: '课件名称',
            name: 'searchName',
            searchItem: {},
        },
        {
            title: '课件名称',
            name: 'name',
            tableItem: {},
        },
        {
            title: '编号',
            name: 'code',
            searchItem: {},
            tableItem: {},
        },
        {
            title: '文件格式',
            name: 'type',
            searchItem: {
                type: 'select',
            },
            tableItem: {},
            dict: [
                {code: 0, codeName: '视频'},
                {code: 1, codeName: '语音'},
                {code: 2, codeName: 'h5'},
                {code: 3, codeName: 'ppt'},
                {code: 4, codeName: 'pdf'},
                {code: 5, codeName: 'scorm'}
              ],
        },
        {
            title: '支持平台',
            name: 'supportsName',
            tableItem: {},
        },
        {
            title: '支持平台',
            name: 'supports',
            searchItem: {type: 'select',},
            dict: [
                {code: 0, codeName: 'PC'},
                {code: 1, codeName: 'APP'}
              ],
        },
        {
            title: '时长',
            name: 'duration',
            tableItem: {},
        },
        // {
        //     title: '截至时间',
        //     name: 'endTime',
        //     tableItem: {},
        // },

    ]
}